import React, { FC } from 'react'
import { updateProfileUrl } from '../helpers'
import { PROFILE, ARTWORKS } from '../helpers/constants'
import styles from './artistProfile.module.scss'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import {
  getPageParamSection,
  getPageParamUserId,
  getArtworksTotal,
  getUserName,
} from '../selectors'
import useQA from 'hooks/useQA'

const Tabs: FC = () => {
  const { testId } = useQA()
  const pageSection = useSelector(getPageParamSection)
  const userId = useSelector(getPageParamUserId)
  const totalArtworks = useSelector(getArtworksTotal)
  const userName = useSelector(getUserName)
  const handleClick = (event: React.SyntheticEvent<HTMLElement>) => {
    event.preventDefault()
    const { section } = event.currentTarget.dataset
    updateProfileUrl({ section, userId, userName })
  }

  return (
    <div className={styles.tabsWrapper}>
      <div className={styles.tabs}>
        <button
          type='button'
          data-section={PROFILE}
          className={classNames(
            {
              [styles.tabActive]: pageSection === PROFILE,
            },
            styles.tab
          )}
          {...testId('tabs')}
          onClick={handleClick}
        >
          Profile
        </button>
        <button
          type='button'
          data-section={ARTWORKS}
          className={classNames(
            {
              [styles.tabActive]: pageSection === ARTWORKS,
            },
            styles.tab
          )}
          onClick={handleClick}
        >
          {`All Artworks (${totalArtworks})`}
        </button>
      </div>
    </div>
  )
}

export default Tabs
